const GET_EMPLOYEE_TEMPLET_START = 'GET_EMPLOYEE_TEMPLET_START';
const GET_EMPLOYEE_TEMPLET_SUCCESS = 'GET_EMPLOYEE_TEMPLET_SUCCESS';
const GET_EMPLOYEE_TEMPLET_ERROR = 'GET_EMPLOYEE_TEMPLET_ERROR';

const GET_COMPANY_INFO_CONGRATS_START = 'GET_COMPANY_INFO_CONGRATS_START';
const GET_COMPANY_INFO_CONGRATS_SUCCESS = 'GET_COMPANY_INFO_CONGRATS_SUCCESS';
const GET_COMPANY_INFO_CONGRATS_ERROR = 'GET_COMPANY_INFO_CONGRATS_ERROR';

const getCompanyInfoCongratulatStart = () => {
	return {
		type: GET_COMPANY_INFO_CONGRATS_START
	};
};

const getCompanyInfoCongratulatSuccess = (res) => {
	return {
		type: GET_COMPANY_INFO_CONGRATS_SUCCESS,
		res
	};
};

const getCompanyInfoCongratulatError = () => {
	return {
		type: GET_COMPANY_INFO_CONGRATS_ERROR,
	};
};

const getEmployeeTempletStart = () => {
	return {
		type: GET_EMPLOYEE_TEMPLET_START
	};
};

const getEmployeeTempletSuccess = (res) => {
	return {
		type: GET_EMPLOYEE_TEMPLET_SUCCESS,
		res
	};
};

const getEmployeeTempletError = () => {
	return {
		type: GET_EMPLOYEE_TEMPLET_ERROR,
	};
};


export default {
	types: {
		GET_EMPLOYEE_TEMPLET_START,
		GET_EMPLOYEE_TEMPLET_SUCCESS,
		GET_EMPLOYEE_TEMPLET_ERROR,

		GET_COMPANY_INFO_CONGRATS_START,
		GET_COMPANY_INFO_CONGRATS_SUCCESS,
		GET_COMPANY_INFO_CONGRATS_ERROR
	},
	creators: {
		getEmployeeTempletStart,
		getEmployeeTempletSuccess,
		getEmployeeTempletError,

		getCompanyInfoCongratulatStart,
		getCompanyInfoCongratulatSuccess,
		getCompanyInfoCongratulatError,
	},
};
